import createPdf, {
  baseFontSize,
  createTableHeader,
  createDividerRow,
  createPages,
  createDocument,
} from '../createPdf';

import { flatMap, pick } from 'lodash';

const createAthleteRow = (athlete, index) => [
  { text: index + 1, alignment: 'right' },
  { text: athlete.lotNumber, alignment: 'right' },
  { text: athlete.name },
  { text: athlete.dateOfBirth },
  { text: athlete.teams.join(', ') },
  { text: athlete.category },
  { text: athlete.entryTotal, alignment: 'right' },
  { text: ' ' },
  { text: ' ' },
  { text: ' ' },
];

const createSignatureLines = names => ({
  fontSize: 12,
  bold: true,
  layout: {
    defaultBorder: false,
  },
  table: {
    widths: ['*', 20, '*', 20, '*'],
    body: [
      [
        { fontSize: 3 * 12, text: ' ', border: [false, false, false, true] },
        ' ',
        { fontSize: 3 * 12, text: ' ', border: [false, false, false, true] },
        ' ',
        { fontSize: 3 * 12, text: ' ', border: [false, false, false, true] },
      ],
      [{ text: names[0] }, ' ', { text: names[1] }, ' ', { text: names[2] }],
    ],
  },
});

const createWeighInListPage = weighInList => {
  let previousCategory;
  const columns = [
    '',
    'LOT',
    'NAME',
    'D.O.B.',
    'TEAM',
    'CAT',
    'ENTRY',
    'B.W.',
    'SN1',
    'CJ1',
  ];
  const widths = [10, 15, '*', 45, 50, 25, 25, 40, 30, 30];
  const rows = flatMap(weighInList.athletes, (athlete, index) => {
    const divider = athlete.category !== previousCategory &&
      !!index && [createDividerRow(columns.length, athlete.category)];
    previousCategory = athlete.category;
    const athleteRow = createAthleteRow(athlete, index);
    return [...(divider || []), athleteRow];
  });
  return [
    {
      text: `WEIGH-IN LIST ${weighInList.title}`,
      style: 'header',
    },
    {
      table: {
        headerRows: 1,
        fontSize: baseFontSize / 1.2,
        widths,
        body: [createTableHeader(columns), ...rows],
      },
    },
    createSignatureLines(['Referee 1', 'Referee 2', 'Referee 3']),
  ];
};

const createWeighInListsPdf = (weighInLists, meta) => {
  const [event] = meta.orm.events;
  const documentDefinition = createDocument(
    'Weigh-in Lists',
    createPages(
      weighInLists,
      createWeighInListPage,
      pick(event, 'title', 'location', 'duration'),
    ),
  );

  return createPdf(documentDefinition);
};

export default createWeighInListsPdf;



// WEBPACK FOOTER //
// ./src/pages/Home/weighInLists/createWeighInListsPdf.js